// extracted by mini-css-extract-plugin
module.exports = {"palette":"ColorPalette_palette__2a7bf","container":"ColorPalette_container__3lAA9","square":"ColorPalette_square__3ktj6"};